import { getPowerAssetsGroupLabel } from "./getPowerAssetsGroupLabel";

export const RecommendedNewPowerAssetsGroupPeriod = (props) => {
  const { cx, endDate, xAxis, yAxis, yoffset, color, count, location } = props;
  const width = xAxis.scale(endDate) - cx;
  const height = 24;
  const y = yAxis.scale(yoffset);
  const iconSize = 14;
  const label = getPowerAssetsGroupLabel(count, location, width);

  // Sometimes due to resizing the width can be negative
  if (width < 0) {
    return null;
  }

  return (
    <svg>
      <rect x={cx} y={y} width={width} height={height} rx={4} fill={color} />
      <text x={cx + 6} y={y + 6} dy={height / 2} fill="white" alignmentBaseline="baseline">
        {label}
      </text>
      {props.icon && (
        <props.icon
          x={xAxis.scale(endDate) - iconSize - 8}
          y={y + height / 4}
          width={iconSize}
          height={iconSize}
          color="white"
        />
      )}
    </svg>
  );
};
